import BrandButton from "@components/Various/BrandButton";
import Link from "next/link";
import React from "react";
import { Plus } from "react-feather";

function OverviewPageHeader({
  title,
  actionText,
  actionLink,
  onActionLinkClick,
}: {
  title: string;
  actionText: string;
  actionLink: string;
  onActionLinkClick?: React.MouseEventHandler<HTMLAnchorElement>;
}) {
  return (
    <h1 className="text-3xl font-bold pb-8 flex flex-col md:flex-row items-start md:items-center gap-3">
      <span>{title}</span>
      <Link href={actionLink} passHref legacyBehavior>
        <BrandButton
          className="ml-auto"
          block={false}
          onClick={onActionLinkClick}
        >
          <div className="flex items-center gap-3">
            <Plus /> {actionText}
          </div>
        </BrandButton>
      </Link>
    </h1>
  );
}

export default OverviewPageHeader;
